class Nuclide {
  /**
   *
   * @param {Object} props
   * @param {Number} props.NEUTRON
   *
   * Sample
   * {"ID":1,"NEUTRON":0,"PROTON":3,"MASS_NUMBER":3,"NAME":"Lithium-3","SYMBOL":" Li-3","PRIMARY_DECAY":"Proton","PRIMARY_GAMMA":"","SECONDARY_DECAY":"","SECONDARY_GAMMA":"","HALF_LIFE":"Need more data","DAUGHTER":"Need more data","USES_ONE":null,"USES_TWO":null,"USES_THREE":null,"USES_FOUR":null,"USES_FIVE":null,"USES_SIX":null,"USES_SEVEN":null}
   */
  constructor(props) {
    for (let key in props) {
      //lower case it
      this[key.toLowerCase()] = props[key];
    }

    this.symbol = this.symbol.trim();
  }

  isIdentical(nuclide) {
    return (
      nuclide &&
      nuclide.neutron === this.neutron &&
      nuclide.proton === this.proton
    );
  }

  getName() {
    return this.name || "None";
  }

  getElementName() {
    if (!this.elementName) {
      this.elementName = this.name?.split("-")[0];
    }
    return this.elementName;
  }

  getUses() {
    return this.uses;
  }

  isExisted() {
    return Boolean(this.name);
  }

  getColor() {
    if (this.name) {
      switch (this.primary_decay?.toLowerCase()?.trim()) {
        case "stable":
          return "#000000";
        case "electron capture/positron":
        case "electron capture x-ray":
        case "double electron capture x-ray":
        case "positron":
          return "#63c6de";
        case "beta minus":
        case "double beta":
          return "#e78cc6";
        case "alpha":
          return "#ffff42";
        case "proton":
          return "#ff9473";
        case "neutron":
          return "#9c7bbd";
        case "spontaneous fission":
          return "#52b552";
        default:
          return "#e0e0e0";
      }
    }
    return "#ffffff";
  }
}

export default Nuclide;
